import React from "react";
import {Button, Divider, Form, Grid, Image} from "semantic-ui-react";
import {NavLink} from "react-router-dom";

export const Recover = () => {

    window.scrollTo(0, 0);

    return (
        <Grid stackable stackable style={{border: '4px solid red', margin: '32px 0'}}>
            <Grid.Row columns={"two"}>
                <Grid.Column
                    only='large screen'
                    style={{
                        backgroundImage: 'url(/images/login-bg.jpg)',
                        backgroundPosition: 'top center',
                    }}
                />
                <Grid.Column className={"signup-form"} textAlign={"center"}>
                    <Image src={"/images/logo-footer-geral.png"} width={160}/>
                    <h3>Não se preocupe, vamos ajudar!</h3>
                    <p>Informe os dados abaixo para enviarmos um link de recuperação de senha:</p>
                    <Form>
                        <Form.Field>
                            <input
                                placeholder='E-mail'
                                autoFocus
                            />
                        </Form.Field>
                        <Button type='submit' color={"red"}>ENVIAR</Button>
                    </Form>

                    <Divider section/>

                    <NavLink to={"/users/login"} className={"ui button basic red"}>VOLTAR PARA O LOGIN</NavLink>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}